export interface CatalogSelectionReconcileResultInterface<T> {
  selected: T[];
  hasStaleKeys: boolean;
}

export const reconcileSelectionByNumericIds = <T extends { id: number; }>(
  catalog: T[],
  requestedIds: (number | string)[] | null | undefined
): CatalogSelectionReconcileResultInterface<T> => {
  const normalizedIds = (requestedIds ?? []).map((id) => (typeof id === 'string' ? +id : id));
  if (!normalizedIds.length) {
    return { selected: [], hasStaleKeys: false };
  }

  const selected = catalog.filter((item) => normalizedIds.includes(item.id));
  return {
    selected,
    hasStaleKeys: selected.length !== normalizedIds.length
  };
};

export const reconcileSelectionByCodes = <T extends { code: string; }>(
  catalog: T[],
  requestedCodes: string[] | null | undefined
): CatalogSelectionReconcileResultInterface<T> => {
  const codes = requestedCodes ?? [];
  if (!codes.length) {
    return { selected: [], hasStaleKeys: false };
  }

  const selected = catalog.filter((item) => codes.includes(item.code));
  return {
    selected,
    hasStaleKeys: selected.length !== codes.length
  };
};
